import React from 'react';
import { Form, Checkbox, Tooltip, Divider, Typography } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { KeyValuePairs } from '../KeyValuePairs';
import './CommonApplianceConfiguration.scss';

const { Title } = Typography;

/**
 * Common Appliance Configuration Component
 * Shared configuration options across all cloud types
 */
export const CommonApplianceConfiguration = ({
    advancedSettingsEnabled,
    onAdvancedSettingsChange,
    migrationInstructions,
    onMigrationInstructionsChange,
    ignoreValidationErrors,
    onIgnoreValidationErrorsChange,
}) => {
    return (
        <>
            <Divider />

            <div className="common-appliance-configuration">
                <Title level={4} className="common-appliance-configuration__title">
                    Advanced Configuration
                </Title>

                <Form.Item name="ignoreValidationErrors" valuePropName="checked">
                    <Checkbox
                        checked={ignoreValidationErrors}
                        onChange={(e) => onIgnoreValidationErrorsChange(e.target.checked)}
                    >
                        <span>
                            Ignore Validation Errors{' '}
                            <Tooltip title="All validation errors should be ignored - please proceed at your own risk.">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </span>
                    </Checkbox>
                </Form.Item>

                <Form.Item name="advancedSettings" valuePropName="checked">
                    <Checkbox
                        checked={advancedSettingsEnabled}
                        onChange={(e) => onAdvancedSettingsChange(e.target.checked)}
                    >
                        Advanced Settings
                    </Checkbox>
                </Form.Item>

                {advancedSettingsEnabled && (
                    <div className="common-appliance-configuration__nested">
                        <Form.Item label="Migration Appliance Instructions">
                            <KeyValuePairs
                                dataSource={migrationInstructions}
                                onChange={onMigrationInstructionsChange}
                                keyPlaceholder="key"
                                valuePlaceholder="value"
                                instructionMessage="Add custom instructions for the migration appliance."
                                limit={50}
                            />
                        </Form.Item>
                    </div>
                )}
            </div>
        </>
    );
};

